import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, LogOut, Moon, Search, Settings, Sun } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useThemeMode } from "@/context/ThemeContext";
import { BrandMark, UserAvatar } from "@/components/common";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ROLE_LABEL } from "@/lib/constants";
import GlobalSearch from "@/components/GlobalSearch";
import NotificationBell from "./NotificationBell";

export default function TopBar() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useThemeMode();
  const [open, setOpen] = useState(false);
  return (
    <header className="glass sticky top-0 z-30 border-b">
      <div className="flex h-16 items-center gap-3 px-4 sm:px-6 lg:px-10">
        <div className="md:hidden">
          <BrandMark compact />
        </div>
        <button
          data-testid="global-search-open-button"
          onClick={() => setOpen(true)}
          className="flex h-10 min-w-0 flex-1 items-center gap-2 rounded-full border bg-card px-4 text-sm text-muted-foreground transition-colors hover:border-primary/40 md:max-w-md"
        >
          <Search className="h-4 w-4" />
          <span className="truncate">Search leads, properties…</span>
        </button>
        <button
          data-testid="theme-toggle-button"
          onClick={toggle}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border bg-card text-muted-foreground transition-colors hover:text-foreground"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
        <NotificationBell />
        <DropdownMenu>
          <DropdownMenuTrigger data-testid="user-menu-trigger" className="shrink-0 rounded-full outline-none ring-primary/30 focus-visible:ring-2">
            <UserAvatar user={user} size="md" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <p className="truncate">{user?.name}</p>
              <p className="text-xs font-normal text-muted-foreground">{ROLE_LABEL[user?.role]} · {user?.mobile}</p>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/settings" data-testid="user-menu-settings"><Settings className="mr-2 h-4 w-4" />Settings</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/change-password" data-testid="user-menu-change-password"><KeyRound className="mr-2 h-4 w-4" />Change password</Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="user-menu-logout" onClick={logout}><LogOut className="mr-2 h-4 w-4" />Log out</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <GlobalSearch open={open} onOpenChange={setOpen} />
    </header>
  );
}
